export enum ChecklistRecordTypeEnum {
  ADD_QUESTION = "ADD_QUESTION",
  REMOVE_QUESTION = "REMOVE_QUESTION",
  UPDATE_QUESTION = "UPDATE_QUESTION",
}

export const getChecklistRecordLabel = (type: ChecklistRecordTypeEnum, entity: string): string => {
  switch (type) {
    case ChecklistRecordTypeEnum.ADD_QUESTION:
      return `Agregó una pregunta a la ${entity}`;
    case ChecklistRecordTypeEnum.REMOVE_QUESTION:
      return `Borró una pregunta de la ${entity}`;
    case ChecklistRecordTypeEnum.UPDATE_QUESTION:
      return `Actualizó una pregunta de la ${entity}`;
  }
};
